import { Component, Vue } from 'vue-property-decorator'
import { queryCourse, createStudent, getWorkOrderSign, editWorkOrder } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
import { UserModule } from '@/store/modules/user'
import urlBase from '@/utils/urlBase'

interface Student {
  nameCn: string;
  firstName: string;
  lastName: string;
  idCard: string;
  headerImageUrl: string;
  major: string; // 专业
  email: string;
  phone: string;
  weiXin: string;
  resumeUrl: string; // 简历
  gender: number | null; // 性别 1,男；2，女
  school: string; // 学校
  grade: string; // 年级
  sources: string; // 来源渠道
  consultingTeacher: string; // 咨询老师
  languageGrade: string;
  remark: string;
  from: string | any;
  orderIdCrm: string | any;
  courseId: string;
  department: string; // 所属部门
  haveFullPaper: boolean | null; // 是否报独立论文
  applicationFormUrl: string; // 报名表
  project: Project | null; // 所报项目
  workOrderSite: string | any; // 当前类型新建还是存草稿
}

interface Project {
  id: string;
  name: string;
  typeStr: string;
  schoolBegins: string;
}

@Component({ name: 'create-student-page' })
export default class CreateStudentPage extends Vue {
  private pageType = 'create'
  private imgUploadHandle: any = null
  private projectList = []
  private id = ''
  private orderType: any = null
  private loading: any = null
  get idis () {
    return this.pageType === 'continue'
  }

  private student: Student = {
    nameCn: '',
    firstName: '',
    lastName: '',
    idCard: '',
    headerImageUrl: '',
    major: '', // 专业
    email: '',
    phone: '',
    weiXin: '',
    resumeUrl: '', // 简历
    gender: null, // 性别 1,男；2，女
    school: '', // 学校
    grade: '', // 年级
    sources: '', // 来源渠道
    consultingTeacher: '', // 咨询老师
    department: '', // 所属部门
    languageGrade: '',
    remark: '',
    courseId: '',
    from: null,
    orderIdCrm: '',
    project: {
      id: '',
      name: '',
      typeStr: '',
      schoolBegins: ''
    },
    workOrderSite: null,
    haveFullPaper: null, // 是否报独立论文
    applicationFormUrl: '' // 报名表
  }

  private time: any = null
  // todo
  private uploadUrl = {
    // headImg: 'http://192.168.0.176:10069/upload/student/headImage',
    headImg: urlBase.eduBaseUrl + 'upload/student/headImage',
    resume: urlBase.eduBaseUrl + 'upload/student/resume',
    applicationForm: urlBase.eduBaseUrl + 'upload/sellOrder/applicationForm'
  }

  created () {
    const query: any = this.$route.query
    this.pageType = query.action
    this.id = query.id
    this.orderType = query.type
    this.initPageData()
  }

  mounted () {
    this.imgUploadHandle = this.$refs['upload-for-img']
  }

  private async initPageData () {
    if (this.pageType === 'edit') {
      await this.initStudentData(this.id)
    } else {
      this.student.consultingTeacher = UserModule.realName
      this.student.department = UserModule.departments[0]
    }
  }

  private async remoteMethod (query: any) {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if (query !== '') {
        const result: any = await queryCourse({ name: query })
        this.projectList = result
      } else {
        this.projectList = []
      }
    }, 200)
  }

  private async initStudentData (id: string) {
    const result: any = await getWorkOrderSign({ id })
    // if (this.orderType * 1 === 2) {
    //   this.$router.push({ path: '/student/continue', query: { id: result.studentId } })
    //   return
    // }
    const buffer = {
      id: result.courseId,
      name: result.courseName,
      typeStr: result.courseTypeStr,
      schoolBegins: result.schoolBegins
    }
    this.remoteMethod(result.courseName)
    this.student = Object.assign({ project: buffer }, result)
    this.onProjectChanged(result.courseId)
  }

  private onUserImageUploadClick () {
    this.imgUploadHandle.click()
  }

  private onProjectChanged (id: string) {
    const data = this.projectList.filter((item: Project) => { return id === item.id })
    if (data.length > 0) {
      this.student.project = JSON.parse(JSON.stringify(data[0]))
      this.student.courseId = id
    }
  }

  // 头像上传回调函数
  private handleAvatarSuccess (res: any) {
    this.student.headerImageUrl = res.data
    this.$message({ message: '上传头像成功', type: 'success' })
    this.loading.close()
  }

  // 简历上传回调函数
  private handleResumeSuccess (res: any) {
    this.$set(this.student, 'resumeUrl', res.data)
    this.$message({ message: '上传简历成功', type: 'success' })
    this.loading.close()
  }

  // 报名表上传回调函数
  private handleApplicationFormSuccess (res: any) {
    this.$message({ message: '上传项目报名表成功', type: 'success' })
    this.$set(this.student, 'applicationFormUrl', res.data)
    this.loading.close()
  }

  // 上传中提示
  private handleApplicationFormProgress () {
    this.loading = this.$loading({
      lock: true,
      text: '上传中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }

  // 报名表上传失败回调函数
  private handleApplicationFormError () {
    this.$message({ message: '上传失败，请重新上传', type: 'error' })
    this.loading.close()
  }

  /**
   * [description] 提交按钮被点击
   */
  private async onSubmit () {
    const param: any = Object.assign({ workOrderId: this.id }, this.student)
    param.isSketch = false
    const check = await this.check()
    if (check !== false) {
      this.$confirm('确定要提交么？').then(async () => {
        if (this.pageType === 'edit' || this.student.workOrderSite === 3) {
          const result: any = await editWorkOrder(param)
          if (result.errorNumber && result.errorNumber === 1) {
            param.goOn = true
            this.$confirm('当前用户已经报名这个课程了，确定要重复报名？').then(async () => {
              const { error }: any = await editWorkOrder(param)
              if (!error) {
                this.$message({ message: '操作成功', type: 'success' })
                this.$router.go(-1)
                TagsViewModule.delView(this.$route)
              }
            })
          } else {
            this.$router.go(-1)
            TagsViewModule.delView(this.$route)
          }
        } else {
          const result: any = await createStudent(param)
          if (result.errorNumber && result.errorNumber === 1) {
            param.goOn = true
            this.$confirm('当前用户已经报名这个课程了，确定要重复报名？').then(async () => {
              const { error }: any = await createStudent(param)
              if (!error) {
                this.$message({ message: '操作成功', type: 'success' })
                this.$router.go(-1)
                TagsViewModule.delView(this.$route)
              }
            })
          } else {
            this.$router.go(-1)
            TagsViewModule.delView(this.$route)
          }
        }
      })
    }
  }

  /**
   * [description] 校验数据不能为空
   */
  private check () {
    if (!this.student.idCard) {
      this.$message({ message: '学生识别号必填项', type: 'error' })
      return false
    }
    if (!this.student.nameCn) {
      this.$message({ message: '中文名必填项', type: 'error' })
      return false
    }
    if (!this.student.email) {
      this.$message({ message: '学员邮箱必填项', type: 'error' })
      return false
    }
    if (!this.student.project || this.student.project.id === '') {
      this.$message({ message: '所报项目必填项', type: 'error' })
      return false
    }
  }

  /**
   * [description] 存为草稿被点击
   */
  private async onSaveDraft () {
    const param = Object.assign({ isSketch: true, workOrderId: this.id }, this.student)
    if (this.pageType === 'edit' || this.student.workOrderSite === 3) {
      const { error }: any = await editWorkOrder(param)
      if (!error) {
        this.$message({ message: '操作成功', type: 'success' })
        this.$router.go(-1)
        TagsViewModule.delView(this.$route)
      }
    } else {
      const { error }: any = await createStudent(param)
      if (!error) {
        this.$message({ message: '操作成功', type: 'success' })
        this.$router.go(-1)
        TagsViewModule.delView(this.$route)
      }
    }
  }
}
